import { ThemeUIStyleObject } from 'theme-ui';

export const pageStyles: ThemeUIStyleObject = {
  backgroundColor: 'neutral/100',
  minHeight: `calc(100vh - 4rem)`,
  flexDirection: 'column',
};

export const contentStyles: ThemeUIStyleObject = {
  flex: 1,
  width: '100%',
  margin: '0 auto',
  padding: ['1rem', '2rem 5rem'], // mobile, desktop
};

export const listStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
};

export const emptyStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '25rem',
  background: 'neutral/000',
  borderRadius: '0.5rem',
  boxShadow: 'medium',
};
